const STORAGE_KEY = 'dale-business-device-id';

/** A stable per-browser id sent with OTP verification, persisted across sessions. */
export function getDeviceId(): string {
  const existing = localStorage.getItem(STORAGE_KEY);
  if (existing) return existing;
  const generated = crypto.randomUUID();
  localStorage.setItem(STORAGE_KEY, generated);
  return generated;
}
